import { PALETTE } from '../board/toolSettings';

/** Palette swatches plus a native colour input. `allowNone` adds a "no colour" swatch. */
export function ColorPicker({
  value,
  onChange,
  allowNone = false,
  label,
}: {
  value: string;
  onChange: (c: string) => void;
  allowNone?: boolean;
  label?: string;
}) {
  const isCustom = value !== 'none' && !(PALETTE as readonly string[]).includes(value);
  return (
    <div className="colors" role="group" aria-label={label}>
      {allowNone && (
        <button
          type="button"
          className={`swatch swatch-none${value === 'none' ? ' is-active' : ''}`}
          title="No colour"
          aria-label="No colour"
          onClick={() => onChange('none')}
        />
      )}
      {PALETTE.map((c) => (
        <button
          key={c}
          type="button"
          className={`swatch${value === c ? ' is-active' : ''}`}
          style={{ background: c }}
          title={c}
          aria-label={c}
          onClick={() => onChange(c)}
        />
      ))}
      <label className={`swatch swatch-custom${isCustom ? ' is-active' : ''}`} title="Custom colour" style={{ background: isCustom ? value : undefined }}>
        <input
          type="color"
          value={value === 'none' || !/^#[0-9a-f]{6}$/i.test(value) ? '#888888' : value}
          onChange={(e) => onChange(e.target.value)}
        />
      </label>
    </div>
  );
}

export function SizePicker({
  value,
  options,
  onChange,
}: {
  value: number;
  options: number[];
  onChange: (n: number) => void;
}) {
  return (
    <div className="sizes" role="group">
      {options.map((n) => (
        <button
          key={n}
          type="button"
          className={`size-btn${value === n ? ' is-active' : ''}`}
          title={`${n}px`}
          aria-label={`${n} pixels`}
          onClick={() => onChange(n)}
        >
          <i style={{ width: Math.min(18, Math.max(2, n)), height: Math.min(18, Math.max(2, n)) }} />
        </button>
      ))}
    </div>
  );
}
